import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAssetType($companyId: ID!, $id: ID!) {
    deleteAssetType(companyId: $companyId, id: $id) {
      assetType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
